exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".mat-dialog-content {\n  height: 195px; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// E:/jenkins_home/workspace/_agenda-unco-front-legacy_master/frontend-web/src/app/components/abm/new-acopio-dialog/new-acopio-dialog.component.scss
// module id = ../../../../../src/app/components/abm/new-acopio-dialog/new-acopio-dialog.component.scss
// module chunks = 0